import { numbers } from './numbers';
import { stats } from './stats';
import { user_countries } from './user_countries';

export const phone_number = {
  namespaced: true,
  modules: {
    numbers,
    stats,
    user_countries
  }
};
